export type DisplayProtocol =
  | 'TCP'
  | 'UDP'
  | 'ALL_TCP'
  | 'ALL_UDP'
  | 'ALL_TRAFFIC';

export interface SecurityGroupRuleState {
  protocol: string;
  fromPort: number;
  toPort: number;
  displayProtocol: DisplayProtocol;
}

export interface AddPrivateLinkWizardState {
  workspaceId: string;
  workspaceRegion: string;
  serviceName: string;
  region: string;
  fqdn: string;
  securityGroupRules: SecurityGroupRuleState[];
  mode: 'create' | 'edit';
  editingPrivateLinkId: string | null;
}

export const defaultAddPrivateLinkWizardState: AddPrivateLinkWizardState = {
  workspaceId: '',
  workspaceRegion: '',
  serviceName: '',
  region: '',
  fqdn: '',
  securityGroupRules: [],
  mode: 'create',
  editingPrivateLinkId: null,
};
